module.exports = __webpack_public_path__ + "img/n5.9045e747.png";